import { Location } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  private history: string[] = [];

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history[0] = this.history[1];
        this.history[1] = event.urlAfterRedirects;
      }
    });
  }

  back(defaultRoute = '/'): void {
    this.history.pop();
    if (this.hasPreviousPage()) {
      this.location.back();
    } else {
      this.router.navigate([defaultRoute], {
        queryParamsHandling: 'merge',
      });
    }
  }

  hasPreviousPage(): boolean {
    return this.history[0] !== undefined;
  }
}
